import React, { Suspense, useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelectedProduct } from "../../reducers/ProductReducer";
import PageHeader from "../../components/page/PageHeader";
import { update_page_meta } from "../../actions/page/header";
import { connect } from "react-redux";
import axios from "axios";
import { JSON_CONTENT_FORM_CONFIG } from "../../actions/Config";
import { selectProduct } from "../../actions/products/products";
import { HomePageURL } from "../../assets/const";

const Detail = ({ update_page_meta, selectProduct }) => {
  const { productSlug } = useParams();
  const selectedProduct = useSelectedProduct();
  const [fetching, setFetching] = useState(true);
  const [stock, setStock] = useState({});
  useEffect(() => {
    const fetchProduct = async () => {
      try{
        setFetching(true)
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/catalog/product-detail/${productSlug}/`,
          JSON_CONTENT_FORM_CONFIG
        );
        if (res.status === 200){
          selectProduct(res.data.product);
        }
      }
      catch{}
      setFetching(false);
    };
    const fetchStock = async () => {
      try{
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/catalog/get-product-stock/${productSlug}/`,
          JSON_CONTENT_FORM_CONFIG
        );
        if (res.status === 200){
          setStock(res.data)
        }
      }
      catch{}
    };
    fetchProduct();
    fetchStock();
  }, [productSlug]);
  const navigate = useNavigate();
  if (!fetching && !selectedProduct){
    navigate(`${HomePageURL}/products/`, {replace: true});
  }
  update_page_meta({
    title: selectedProduct?.display_name ?? "Product Detail",
    description: "Product detail",
  });
  const TopInfoBar = ({ title, value, href }) => {
    return (
      <Link to={href} 
        className="d-flex" 
        style={{
          border: "1px solid black", 
          flex: 1, padding: "15px 10px", 
          background: "white", 
          justifyContent: "space-between",
          textDecoration: "none"}}>
        <span>{title}</span>
        <span style={{fontWeight: "600"}}>{value}</span>
      </Link>
    )
  }
  return (
    <>
      <PageHeader title={selectedProduct?.display_name} />
      <div className="row layout-top-spacing" id="cancel-row">
        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
          <div className="d-flex" style={{flexDirection: "row", justifyContent: "space-between"}}>
            {selectedProduct?.product_type === 2 && <TopInfoBar title="Variants" value={selectedProduct?.variants_count ?? 0} href={`${HomePageURL}/products/?variantsof=${productSlug}`} />}
            <TopInfoBar title="In Stock" value={(stock?.PRODUCED ?? 0) + (stock?.IN_WAREHOUSE ?? 0)} href={`${HomePageURL}/fg/?product=${productSlug}&status=PRODUCED,IN_WAREHOUSE`} />
            <TopInfoBar title="Sold" value={stock?.SOLD ?? 0} href={`${HomePageURL}/fg/?product=${productSlug}&status=SOLD`} />
            <TopInfoBar title="Dealer Stock" value={stock?.WITH_DEALER ?? 0} href={`${HomePageURL}/fg/?product=${productSlug}&status=WITH_DEALER`} />
          </div>
          <div className="widget-content widget-content-area br-6">
            
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { update_page_meta, selectProduct })(Detail);
